// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader } from "@revvsales/components";
import UPLOAD_IMG from "../../assets/attachment-icons/grouped_attachment.png";

// SERVICE Imports
import {
  documentAttachmentService,
  fetchDocumentAttachmentsService,
  removeAttachmentService,
} from "../../actions/DocumentActions/services";

// Components Imports
import AttachmentItem from "./AttachmentItem";

// Internal Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { handleApiErrMsg } = GlobalUtils;
class AttachmentComponent extends Component {
  dropRef = React.createRef();

  constructor(props) {
    super(props);
    this.dragCounter = 0;
    this.state = {
      drag: false,
      attachments: [],
      loaderStatus: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    const div = this.dropRef.current;
    if (div) {
      div.addEventListener("dragenter", this._handleDragIn);
      div.addEventListener("dragleave", this._handleDragOut);
      div.addEventListener("dragover", this._handleDrag);
      div.addEventListener("drop", this._handleDrop);
    }

    // get Attachement api call
    this._getAttachmentList();
  }

  componentWillUnmount() {
    const div = this.dropRef.current;
    if (div) {
      div.removeEventListener("dragenter", this._handleDragIn);
      div.removeEventListener("dragleave", this._handleDragOut);
      div.removeEventListener("dragover", this._handleDrag);
      div.removeEventListener("drop", this._handleDrop);
    }
  }

  _getAttachmentList = () => {
    fetchDocumentAttachmentsService(this.props.docID, this.props.sharingHash)
      .then(res => {
        this.setState({
          attachments: res.Attachments,
          errorMessage: "",
        });
      })
      .catch(error => {
        const message = handleApiErrMsg(error);
        this.setState({
          errorMessage: message,
        });
        this._clearErrorMessage();
      });
  };

  _handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  _handleDragIn = e => {
    e.preventDefault();
    e.stopPropagation();
    // eslint-disable-next-line no-plusplus
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  };

  _handleDragOut = e => {
    e.preventDefault();
    e.stopPropagation();
    // eslint-disable-next-line no-plusplus
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }
  };

  _handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this._postFileDataToServer(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  };

  _uploadAttachment = e => {
    if (e.target.files[0]) {
      this._postFileDataToServer(e.target.files[0]);
    }
  };

  _postFileDataToServer = data => {
    this.setState({
      loaderStatus: true,
    });
    const thumbnail = "";
    documentAttachmentService(
      this.props.docID,
      data,
      thumbnail,
      this.props.sharingHash,
    )
      .then(res => {
        const { attachments } = this.state;
        attachments.push(res.Attachment);
        this.setState({
          attachments,
          loaderStatus: false,
        });
      })
      .catch(error => {
        this.setState({
          loaderStatus: false,
        });
        const message = handleApiErrMsg(error);
        if (
          error.response.status === 413 &&
          message === "File is too big, Max limit is 50 MB"
        ) {
          this.setState({
            errorMessage:
              "This file is too big, please select a file within 50 MB",
          });
        } else {
          this.setState({
            errorMessage:
              "This file type is not supported. Try uploading images, word files or spreadsheets",
          });
        }
        this._clearErrorMessage();
      });
  };

  _removeAttachment = (e, index) => {
    e.stopPropagation();
    const { attachments } = this.state;
    removeAttachmentService(attachments[index].ID, this.props.docID)
      .then(() => {
        attachments.splice(index, 1);
        this.setState({
          attachments,
        });
      })
      .catch(error => {
        const message = handleApiErrMsg(error);
        this.setState({
          errorMessage: message,
        });
        this._clearErrorMessage();
      });
  };

  _viewFile = (isVideo, index) => {
    if (!isVideo) {
      window.open(this.state.attachments[index].Link);
    }
  };

  _clearErrorMessage = () => {
    setTimeout(() => this.setState({ errorMessage: "" }), 5000);
  };

  render() {
    const { attachments, loaderStatus, errorMessage } = this.state;
    return (
      <Fragment>
        <div className="attachment-container animated fadeinright">
          <div className="attachment-header">Attachments</div>
          <div className="attachment-body-wrapper">
            <div className="content-scroll">
              <div className="attachment-box">
                <div className="attachment-above-size-container">
                  {errorMessage && (
                    <span className="attachment-size-error-message">
                      <FontAwesomeIcon
                        icon={["far", "exclamation-triangle"]}
                        className="attachment-triangle-icon "
                      />
                      {errorMessage}
                    </span>
                  )}
                </div>
                <div className="attachment-upload-section">
                  <img
                    src={UPLOAD_IMG}
                    className="attachment-upload-image"
                    alt="attachment"
                  />
                </div>
                <div className="attachment-upload-message-section">
                  Upload files relevant to your document here. When you share
                  the documents with someone, they will be able to access these
                  attachments as well.
                </div>
                <div
                  className={
                    this.state.drag
                      ? "attachment-while-dragging"
                      : "attachment-upload-box"
                  }
                  ref={this.dropRef}>
                  {loaderStatus ? (
                    <Loader
                      className="loader-bg-color attachment-loader"
                      label="Uploading"
                    />
                  ) : (
                    <label
                      htmlFor="file-attachment"
                      className="attachment-label">
                      <FontAwesomeIcon icon={["far", "paperclip"]} />
                      Drag and drop files (or) browse to upload
                      <input
                        type="file"
                        id="file-attachment"
                        className="attachment-file"
                        onChange={this._uploadAttachment}
                        data-test="attachmentcomponent-input"
                      />
                    </label>
                  )}
                </div>
              </div>

              {attachments.length > 0 &&
                attachments.map((data, index) => (
                  <AttachmentItem
                    isSharedDocument={this.props.isSharedDocument}
                    viewFile={isVideo => this._viewFile(isVideo, index)}
                    removeItem={e => this._removeAttachment(e, index)}
                    {...data}
                  />
                ))}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID, status, docType },
  } = state.DocumentStore;
  return {
    docID,
    status,
    docType,
  };
};

export default connect(
  mapStateToProps,
  null,
)(AttachmentComponent);



// WEBPACK FOOTER //
// ./src/components/AttachmentComponent/index.js